module.exports = __webpack_public_path__ + "static/media/liability_insurance.af2903bc.svg";